import { render, staticRenderFns } from "./modal_pdf_pedido.vue?vue&type=template&id=8d4cbe16&"
import script from "./modal_pdf_pedido.vue?vue&type=script&lang=js&"
export * from "./modal_pdf_pedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports